import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class CustomStyleService {
  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  public setCustomStyle(webOption) {
    for (const key in webOption) {
      const styles = webOption[key]

      for (const style in styles) {
        let varName = style
        if (key != 'root') {
          varName = `${style}-${key.replace('.', '')}`
        }

        this.document.documentElement.style.setProperty(varName, styles[style])
      }
    }
  }
}
